import { DoughnutWithLegend } from "app/components/static-charts/doughnut-with-legend";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useMemo } from "react";

export const BusinessChart = ({ innerText }) => {
  const { t: trans } = useTranslation();

  const data = {
    labels: [trans("Product"), trans("Service")],
    datasets: [
      {
        data: [65, 35],
        borderColor: "#00000000",
        backgroundColor: ["#E5FF00", "#937AF7"],
      },
    ],
  };
  const options = useMemo(() => {
    return {
      cutout: "85%",
      responsive: true,
      elements: {
        center: {
          text: innerText,
          color: "#ffffff",
          fontStyle: "Montserrat",
          sidePadding: 30,
          minFontSize: 20,
          lineHeight: 25,
          innerRadius: 70,
          fontWeight: 600,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
      },
    };
  }, [innerText]);

  return (
    <DoughnutWithLegend
      data={data}
      options={options}
      textCss="text-white text-[13px] leading-[13px]"
      legendCss="ltr:md:ml-5 ml-0 pb-4 rtl:md:mr-5"
    />
  );
};

BusinessChart.propTypes = {
  innerText: PropTypes.string,
};
